export default __webpack_public_path__ + "static/media/house-2.f07f13ee.jpeg";